// extracted by mini-css-extract-plugin
export default {"mainContainer":"MinistryRequestHistoryTable_mainContainer__XeNnF"};